import styled from 'styled-components';
import { Switch } from 'antd';

const ASwitch = styled(Switch)`
  border: none;
`;

export default ASwitch;
